export const sessionRTTI = Symbol.for("Session");
export const sessionOptionsRTTI = Symbol.for("SessionOptions");
